import React from 'react';
import Layout from '../../Components/Layout';
import { Box, Grid, Typography } from '@mui/material';
import OutlookConnection from './OutlookConnection';
import GmailConnection from './GmailConnection';
import { useSelector } from 'react-redux';

function EmailSetup() {
  // Read connection states from their respective slices
  const emailState = useSelector((state) => state.email);
  const gmailState = useSelector((state) => state.email); // gmailConnected lives in email reducer
  const hasOutlook = !!(emailState?.emailData && emailState.emailData.outlook && (emailState.emailData.outlook.clientId || emailState.emailData.outlook.senderEmail));
  const hasGmail = !!gmailState?.gmailConnected;
  return (
    <Layout>
      <Box sx={{ maxWidth: 1200, mt: 3, px: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Email Setup</Typography>
        <Typography variant="body2" sx={{ mb: 3, color: '#6b7280' }}>
          You will need admin access to your email provider and domain settings to complete the email and domain setup.
        </Typography>

        <Grid container spacing={3}>
          {(!hasGmail) && (
            <Grid size={{ xs: 12, md: 6, lg: 4, sm: 12 }}>
              <OutlookConnection />
            </Grid>
          )}
          {/* {(!hasOutlook) && (
            <Grid size={{ xs: 12, md: 6, lg: 4, sm: 12 }}>
              <GmailConnection />
            </Grid>
          )} */}
        </Grid>
      </Box>
    </Layout>
  );
}

export default EmailSetup;
